import {KeyCode} from '../../constants';

export const ListQa = {
    ACTIVE_ITEM: 'list-active-item',
};

export const listNavigationIgnoredKeys = [
    // Tab key should focus the next element
    KeyCode.TAB,
];
